<template>
    <header>
        <div class="navbar navbar-dark bg-orange box-shadow page-title">
            <div class="container d-flex justify-content-between ">
              <span>{{nav_title}} <small>{{nav_subtitle}}</small></span> <small>{{nav_info}}</small>
            </div>
        </div>
    </header>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Navbar',
  computed: mapGetters({
    nav_title: 'getNavTitle',
    nav_subtitle: 'getNavSubtitle',
    nav_info: 'getNavInfo'
  })
}

</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue